import React from 'react';
import { StageSection, Prose, KeyPoints } from '../../ContentPrimitives';
import { StageBlock, content, question } from '../../types';

export const meta = {
    title: 'Rent & Ownership',
    tagline: 'Storage isn\'t free, and only the owner gets to write.',
};

// This stage expects 2 quiz questions configured in the admin panel, in this order:
//   Q0 - the purpose of rent-exemption
//   Q1 - the ownership rule for who can modify an account
export const blocks: StageBlock[] = [
    content('rent', () => (
        <StageSection gradientBorder eyebrow="Stage 5 of 8" title="Rent: paying to exist on-chain">
            <Prose>
                Storing data on Solana isn't free forever by default. Every account must maintain a minimum SOL
                balance proportional to how much data it stores, in order to be "rent-exempt." An account that falls
                below that threshold risks being purged from the ledger. This exists to keep the network's total
                storage from growing without bound: every byte kept in the global state has to be paid for by
                someone.
            </Prose>
        </StageSection>
    )),

    question(0),

    content('ownership', () => (
        <StageSection title="Ownership is a hard boundary, not a convention">
            <Prose>
                Recall from Stage 2 that every account has an owner field. That's not just metadata; it's enforced
                by the runtime itself: only the program recorded as an account's owner can modify that account's
                data, or reduce its lamport balance below the rent-exempt minimum. A program can, in controlled
                ways, reassign ownership of an account it currently owns to another program, a pattern that
                underlies more advanced constructs like Program Derived Addresses, covered in depth elsewhere on
                this platform.
            </Prose>
            <KeyPoints items={[
                <>The runtime, not the program's own logic, enforces the ownership boundary.</>,
                <>Confusing "who signed this transaction" with "who owns this account" is a recurring source of real vulnerabilities, explored fully in the Solana security tracks.</>,
            ]} />
        </StageSection>
    )),

    question(1),
];
